<template>
	<div class="learner_dashboard modern_dashboard" aria-label="Home Page">

<!--		<div class="row page_content_container" style="background-image: url(https://pragya2-staging.s3-us-west-2.amazonaws.com/672b5d921d1ca412332d29ef-hero-bg-small-size.png?versionId=gD4rC9bmwwB4w8nR91vtdPVXisJMR7ah); background-position: center;" >
-->
<div class="row page_content_container" v-bind:style="{ backgroundImage: 'url(' + dashboardBackgroundUrl+ ')'}" style="background-size: cover; background-position: center;">

			<div class="col-12">
				<!--
				<div class="row">
					<div class="col-12 pg_sec_head">
		      </div>
				</div>
				-->
				<div class="row" style="height: 100%;">
					<div class="col-12" style="margin: auto;">
						<div class="row comp_row" v-if="courses.length>0">
							<div class="comp_col comp_col_1 col-4" v-if="courses.length>0">
								<learner-program-course-learn-v2 :program="programGuide" :courseStream="courses[0]"></learner-program-course-learn-v2>
							</div>
							<div class="comp_col comp_col_2 col-4" v-if="courses.length>1">
								<learner-program-course-learn-v2 :program="programGuide" :courseStream="courses[1]"></learner-program-course-learn-v2>
							</div>
							<div class="comp_col comp_col_3 col-4" v-if="courses.length>2">
								<learner-program-course-learn-v2 :program="programGuide" :courseStream="courses[2]"></learner-program-course-learn-v2>
							</div>
						</div>
						<div class="row comp_row" v-if="courses.length==0">
							<div class="comp_col col-12" v-if="isDataLoaded">
								<learner-explore-programs></learner-explore-programs>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>

	</div>
</template>

<script>
	import _ from 'lodash'
	import { mapState, mapActions } from 'vuex'
	import { PACKAGE } from '../../../package_constants'
	import LearnerProgramCourseLearnV2 from './LearnerProgramCourseLearnV2'
	import LearnerExplorePrograms from './LearnerExplorePrograms'
	import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

	export default {
		name: 'modern-dashboard',
		components: {
      LearnerProgramCourseLearnV2,
      LearnerExplorePrograms
    },
		data: () => {
			return {
				programGuide: '',
        courses: [],
        careerGoalPragyaSoc: '',
				isDataLoaded: false,
				firstCourse:1,
				secondCourse:4,
				bgImage:'',
				dashboardBackgroundUrl:'',
				modernDashboardComponents : [["LEARNINGV2","LEARNINGV2"],["LEARNINGV2", "LEARNINGV2"]],
				userObject: JSON.parse(localStore.getItem('userobj'))
			}
		},
		beforeMount () {
			this.populateDashboardData()
    },
    mounted () {
    	this.$root.$on('reloadLearnerDashboard', () => {
	      this.populateDashboardData()
	    })
    },
	  watch: {
	    '$route' (to, from) {
	    		if(to.fullPath !==from.fullPath && to.fullPath.indexOf('/dashboard/modern')!=-1){
	    				this.populateDashboardData()
	    		}
	    }
	  },
    computed: {
    	...mapState({
    		'enabledFeatures': state => state.institution.enabledFeatures,
    		'institution': state => state.institution.institution,
	      'learnerDashboardComponents': state => state.dashboard.learnerDashboardComponents
	    }),
			userName () {
        return this.userObject.firstName
      },
      isExplorePackageEnabled () {
	      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_FEATURE_ID]
	      if (exploreFeature) {
	        return exploreFeature.enabled
	      }
	      return false
	    }
		},
		methods: {
			...mapActions([
				'loadLearnerDashboardState',
	      'loadLearnerEnrolledProgram',
	      'loadLearnerEnrolledProgramForCode',
	      'loadLearnerEnrollmentData',
	      'loadStreamWithStructure',
        'loadCareer'
	    ]),
	    async populateDashboardData () {
	    	let userObj = JSON.parse(localStore.getItem('userobj'))
	    	await this.loadLearnerDashboardState()
	    	await this.loadLearnerEnrollmentData()
	    	let dashboardProgram = localStore.getItem('dashboardProgram')
	    	// If dashboardProgram is different from Major1, take user to dashboardProgram
        if (userObj.major1) {
          if(!dashboardProgram || dashboardProgram === 'undefined'|| userObj.major1 === dashboardProgram){
          		this.programGuide = await this.loadLearnerEnrolledProgram()
          }else{
          		this.programGuide = await this.loadLearnerEnrolledProgramForCode(dashboardProgram)
          }
          this.dashboardBackgroundUrl = (this.programGuide.dashboardBGURL && this.programGuide.dashboardBGURL.length>11)?this.programGuide.dashboardBGURL:this.institution.dashboardBgImage
		      let stream = await this.loadStreamWithStructure({programCode: this.programGuide.code})
	        let structure = stream.structure
	        if (structure) {
	          let children = JSON.parse(structure)
	          if (children.length > 0) {
	            let childStructure = children[0].structure
	            this.parentCategory = children[0]
	            if (childStructure) {
	              let structure = JSON.parse(childStructure)
	              this.courses = _.sortBy(structure, 'order')
	            }
	          }
	         }

          setTimeout(() => {
            this.isDataLoaded = true
          }, 0)
		    } else {
	      	this.isDataLoaded = true
	      }


	    }
	  }
	}
</script>



// WEBPACK FOOTER //
// src/app/dashboard/components/ModernDashboard.vue